import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../../../../../shared/functions/Functions';

interface IOfferHeaderProps {
    createdAt: string;
    offerModalStatus: string;
    isEditable?: boolean;
    isRequested?: boolean;
    status?: string;
    acceptedDate?: string;
}

export function InfluencerOfferHeader({
    createdAt,
    offerModalStatus,
    isEditable,
    isRequested,
    status,
    acceptedDate,
}: IOfferHeaderProps) {
    const { t } = useTranslation();

    const isAcceptedOrCompleted = status === 'accepted' || status === 'completed';

    const dateToUse = isAcceptedOrCompleted && acceptedDate ? acceptedDate : createdAt;

    const label = isAcceptedOrCompleted
        ? t('brand.campaign.book.offer.modal.accepted_at')
        : isEditable
        ? t('brand.campaign.book.offer.modal.received_at')
        : t('brand.campaign.book.offer.modal.sent_at');
    return (
        <>
            {offerModalStatus !== 'negotiate' && (
                <div className="d-flex justify-content-between justify-content-md-end">
                    <h6 className="mb-0 d-md-none">{t('brand.campaign.book.offer.modal.offer_item')}</h6>

                    <p className="text-muted w-md-100 text-end mb-0">
                        {isRequested && (
                            <span className="mr-2 status invite text-dark" style={{ fontSize: 10 }}>
                                {t(`general.campaign_status.invite`)}
                            </span>
                        )}
                        {label} – {formatDate(dateToUse)} – {dateToUse.substring(11, 16)}
                    </p>
                </div>
            )}
        </>
    );
}
